import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../../translations.json';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        // Check localStorage for saved language preference
        const savedLang = localStorage.getItem('quickserve_language');
        return savedLang || 'en'; // Default to English
    });

    useEffect(() => {
        localStorage.setItem('quickserve_language', language);
        document.documentElement.lang = language;
    }, [language]);

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        
        for (const k of keys) {
            if (value && value[k]) {
                value = value[k];
            } else {
                // Fallback to English if key not found
                value = translations['en'];
                for (const fallbackKey of keys) {
                    if (value && value[fallbackKey]) {
                        value = value[fallbackKey];
                    } else {
                        return key; // Return key if not found
                    }
                }
                break;
            }
        }
        
        return value;
    };

    // Function to replace placeholders like {name} in translations
    const tReplace = (key, replacements = {}) => {
        let text = t(key);
        Object.keys(replacements).forEach(placeholder => {
            text = text.replace(`{${placeholder}}`, replacements[placeholder]);
        });
        return text;
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'en' ? 'sv' : 'en');
    };

    const value = {
        language,
        setLanguage,
        toggleLanguage,
        t,
        tReplace
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}

export default LanguageContext;
